import { useEffect, useState } from "react";

const CITIES = [
  { city: "Washington", tz: "America/New_York" },
  { city: "Tel Aviv",   tz: "Asia/Jerusalem" },
  { city: "Tehran",     tz: "Asia/Tehran" },
];

const TABS = [
  ["news",       "NEWS"],
  ["unverified", "UNVERIFIED"],
  ["deeper",     "DEEPER"],
  ["idea",       "IDEA"],
  ["anchor",     "ANCHOR"],
];

export default function PCHeader({ active, onTab, onSearch, lang, setLang }) {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setTime(new Date()), 30000);
    return () => clearInterval(t);
  }, []);

  return (
    <header style={{ flexShrink: 0, background: "var(--pc-bg-1)", borderBottom: "1px solid var(--pc-line-3)" }}>
      {/* Row 1: Logo + tabs + search */}
      <div style={{ display: "flex", alignItems: "center", height: 54, padding: "0 28px", borderBottom: "1px solid var(--pc-line-3)" }}>
        <div style={{ fontSize: 18, fontWeight: 800, letterSpacing: "-.01em", color: "var(--pc-fg-1)", marginRight: 44 }}>
          Desert Eye
        </div>
        <nav style={{ display: "flex", gap: 0, alignItems: "center", flex: 1 }}>
          {TABS.map(([id, label]) => {
            const on = active === id;
            return (
              <button
                key={id}
                onClick={() => onTab(id)}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: "0 20px",
                  height: 54,
                  fontSize: 11,
                  letterSpacing: ".14em",
                  textTransform: "uppercase",
                  color: on ? "var(--pc-fg-1)" : "var(--pc-fg-3)",
                  fontWeight: on ? 700 : 500,
                  position: "relative",
                  fontFamily: "var(--pc-font-sans)",
                }}
              >
                {label}
                {on && <span style={{ position: "absolute", left: 12, right: 12, bottom: -1, height: 2, background: "rgba(255,255,255,.6)" }} />}
              </button>
            );
          })}
        </nav>
        <button
          onClick={onSearch}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            background: "transparent",
            border: "1px solid var(--pc-line-3)",
            padding: "0 12px",
            height: 32,
            minWidth: 220,
            color: "var(--pc-fg-3)",
            fontSize: 12,
            cursor: "pointer",
            fontFamily: "var(--pc-font-sans)",
            borderRadius: 0,
          }}
        >
          <span style={{ fontSize: 13, lineHeight: 1 }}>⌕</span>
          <span style={{ flex: 1, textAlign: "left", letterSpacing: ".01em" }}>키워드, 매체, 기자</span>
          <span style={{ fontFamily: "var(--pc-font-mono)", fontSize: 10, color: "var(--pc-fg-4)", letterSpacing: ".05em" }}>⌘K</span>
        </button>
        {setLang && (
          <button
            onClick={() => setLang(l => l === "ko" ? "en" : "ko")}
            style={{
              background: "transparent",
              border: "1px solid var(--pc-line-3)",
              color: "var(--pc-fg-2)",
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: ".12em",
              padding: "0 12px",
              height: 32,
              marginLeft: 10,
              cursor: "pointer",
              fontFamily: "var(--pc-font-sans)",
              borderRadius: 0,
              display: "flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            <span style={{ color: lang === "ko" ? "var(--pc-fg-1)" : "var(--pc-fg-4)" }}>KO</span>
            <span style={{ color: "var(--pc-line-2)" }}>|</span>
            <span style={{ color: lang === "en" ? "var(--pc-fg-1)" : "var(--pc-fg-4)" }}>EN</span>
          </button>
        )}
      </div>

      {/* Row 2: 3-city clocks */}
      <div style={{ display: "flex", alignItems: "center", height: 30, padding: "0 28px", fontVariantNumeric: "tabular-nums" }}>
        <div style={{ display: "flex", gap: 24, alignItems: "baseline", flex: 1 }}>
          {CITIES.map(({ city, tz }) => (
            <div key={tz} style={{ display: "flex", gap: 6, alignItems: "baseline" }}>
              <span style={{ fontSize: 10, color: "var(--pc-fg-3)", fontWeight: 600, letterSpacing: ".08em", textTransform: "uppercase" }}>{city}</span>
              <span style={{ fontSize: 11.5, color: "var(--pc-fg-1)", fontWeight: 600, letterSpacing: ".01em" }}>
                {time.toLocaleTimeString("en-US", { timeZone: tz, hour: "2-digit", minute: "2-digit", hour12: false })}
              </span>
            </div>
          ))}
        </div>
        <span style={{ fontSize: 9.5, color: "var(--pc-fg-3)", letterSpacing: ".10em", textTransform: "uppercase", fontWeight: 700 }}>
          Updated {time.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: false })}
        </span>
      </div>
    </header>
  );
}
